import { render } from "./ArticlePage.vue?vue&type=template&id=f1a81daa&scoped=true"
import script from "./ArticlePage.vue?vue&type=script&lang=js"
export * from "./ArticlePage.vue?vue&type=script&lang=js"

import "./ArticlePage.vue?vue&type=style&index=0&id=f1a81daa&scoped=true&lang=css"
import "./ArticlePage.vue?vue&type=style&index=1&id=f1a81daa&scoped=true&lang=css"
import "./ArticlePage.vue?vue&type=style&index=2&id=f1a81daa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1a81daa"]])

export default __exports__